import { Component,Input,OnInit, Output, EventEmitter } from '@angular/core';
import { SociedadService } from '../../services/sociedades.service';
import { VersionService } from '../../services/version.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

class RfcNombre {
  rfc: string;
  razonSocial: string;
  numeroDeVersion: number[] = [];
  concepto: string[] = [];
  fecha: Date[] = [];
  tipo: string;
}

interface Sociedad {
  rfc: string;
  razonSocial: string;
}

class MostrarVersiones {
  concepto: string;
  fecha: Date;
}

@Component({
  selector: 'app-society-selector',
  templateUrl: './society-selector.component.html',
  styleUrls: ['./society-selector.component.css']
})



export class SocietySelectorComponent implements OnInit {

  @Input() message: any;
  @Input() selectedSociety: string;

  @Output() societySelected = new EventEmitter<string>();

  searchTerm: string = '';
  filteredSociedadLista: Sociedad[] = [];
  sociedadLista: RfcNombre[] = [];
  noHaySociedad = false;
  existeHaySociedad = false;
  listaVersion: MostrarVersiones[] = [];
  tipoSociedad = '';
  listaVersionMostrar = false;
  userName: string;
  rfcSociedadInput: any;

  constructor(private sociedadService: SociedadService,
    private versionService: VersionService, 
    private spinner: NgxSpinnerService,
    private router: Router,
    private toastr: ToastrService, 
  ) 
  {
    this.opcionSocieda();
    console.log(this.sociedadLista);
    this.userName = localStorage.getItem('nombre');
    this.sortAndFilterList();
  }

  ngOnInit(): void {
      
  }

  // Function to filter and sort the list based on search term
  sortAndFilterList() {
    // this.filteredSociedadLista = this.sociedadLista.slice();
    // console.log('sociedades: '+sociedadLista)
    if (this.searchTerm == '*') {
      // If searchTerm is empty, show all items
      this.filteredSociedadLista = this.sociedadLista.slice();
      this.filteredSociedadLista.sort((a, b) => a.razonSocial.localeCompare(b.razonSocial));
      // console.log('empty search...'+this.searchTerm);
      // console.log('sociedadLista..'+this.sociedadLista);
    } else {
      // Filter and sort the list based on the search term
      console.log('Searching for...'+this.searchTerm);
      this.filteredSociedadLista = this.sociedadLista
        .filter(item => item.razonSocial.toLowerCase().includes(this.searchTerm.toLowerCase()))
        .sort((a, b) => a.razonSocial.localeCompare(b.razonSocial));
    }
  }

  // Call this method whenever the search term changes
  onSearchChange() {
    this.sortAndFilterList();
  }

  opcionSocieda() {
    console.log("Inside opcionSocieda");
    let rfcUsuario: string = localStorage.getItem('idUsuario');
    if (rfcUsuario === 'Tracer') {
      console.log('ES TRACER');
      this.sociedadesTracer();
    } else {
      console.log('NO ES TRACER');
      this.sociedadesUsuario(rfcUsuario);
    }
  }

  sociedadesTracer() {
    console.log("Inside sociedadesTracer");
    this.spinner.show();
    this.sociedadService.getAll(0, 1000).subscribe(
      message => {
        if (message['httpStatus'] === 200) {
          let lSociedades = message['sociedades'].length;
          if(lSociedades > 0){
            this.noHaySociedad = false;
            this.existeHaySociedad = true;
            for (let i = 0; i < lSociedades; i++) {
            this.loadVersionesSociedad(message['sociedades'][i].rfc, message['sociedades'][i].razonSocial,message['sociedades'][i].tipo);
            }
          } else {
            this.noHaySociedad = true;
            this.existeHaySociedad = false;
            this.spinner.hide();
            console.log('No ESTA SUSCRITO A NINGUNA SOCIEDAD');
          }
        } else {
          this.showMessage('danger', 'Error', message['messageDetail']);
        }
      },
      error => {
        if (error.status === 0) {
          this.showMessage('error', 'Error de conexión', 'No existe conexión para obtener las sociedades');
        } else if (error.status === 403) {
          this.showMessage('error', 'La sesión expiro', 'Tiempo de sesión expirado');
          this.goLogin();
        } else {
          this.showMessage('error', 'Error en el servidor', 'Error desconocido, contacte con TuVidaDigital');
          this.goLogin();
        }
      },
      () => {
        this.spinner.hide();
      }
    );
  }

  sociedadesUsuario(rfcUsuario: string) {
    console.log("inside sociedadesUsuario");
    this.spinner.show();
    console.log('obtenerUsuarios');
    console.log(rfcUsuario);
    this.sociedadService.getAccesSociedad(rfcUsuario).subscribe(
      message => {
        console.log(message['httpStatus']);
        if (message['httpStatus'] === 200) {
          console.log('NUmerousuario');
          let lSociedades = message['sociedades'].length;
          console.log('NUmerousuario');
          console.log(lSociedades);
          if(lSociedades > 0){
            this.noHaySociedad = false;
            this.existeHaySociedad = true;
            for (let i = 0; i < lSociedades; i++) {
            this.loadVersionesSociedad(message['sociedades'][i].rfc, message['sociedades'][i].razonSocial, message['sociedades'][i].tipo);
            }
          } else {
            this.noHaySociedad = true;
            this.existeHaySociedad = false;
            this.spinner.hide();
            console.log('No ESTA SUSCRITO A NINGUNA SOCIEDAD');
          }
        }
        if (message['httpStatus'] === 400) {
          this.noHaySociedad = true;
          this.existeHaySociedad = false;
          this.spinner.hide();
          console.log('No ESTA SUSCRITO A NINGUNA SOCIEDAD');
        } else {
          this.showMessage('danger', 'Error', message['messageDetail']);
        }
      },
      error => {
        console.log("inside sociedadesUsuario error")
        this.spinner.hide()
        if (error.status === 0) {
          this.showMessage('error', 'Error de conexión', 'No existe conexión para obtener las sociedades sociedadesUsuario');
        } else if (error.status === 403) {
          this.showMessage('error', 'La sesión expiro', 'Tiempo de sesión expirado sociedadesUsuario');
          this.goLogin();
        } else {
          this.showMessage('error', 'Error en el servidor', 'Error desconocido, contacte con TuVidaDigital sociedadesUsuario');
          this.goLogin();
        }
      },
      () => {
        this.spinner.hide();
      }
    );
  }

  loadVersionesSociedad(rfc: string, razonSocial: string, tipo: string) {
    // var z = arguments.callee.name;

    
    this.versionService.getListVersionSociedad(rfc).subscribe(
      message => {
        if (message['httpStatus'] === 200) {
          let Nversiones = Number(message['versiones'].length);
          let numeroVersiones: number [] = [];
          let conceptoVersiones: string [] = [];
          let fechaVersiones: Date [] = [];
          for (let i = 0; i < Nversiones; i++) {
            /*numeroVersiones.push(i);
            console.log(message['versiones'][i].concepto);
            console.log(Nversiones);
            console.log(i);
            console.log(rfc);
            console.log('######3');*/
            conceptoVersiones.push(String (message['versiones'][i].concepto));
            let dateString = message['versiones'][i].fecha;
            let newDate = new Date(dateString);
            fechaVersiones.push(newDate);
          }
            let sociedad = {
              rfc: rfc,
              razonSocial: razonSocial,
              numeroDeVersion: numeroVersiones,
              concepto: conceptoVersiones,
              fecha: fechaVersiones,
              tipo: tipo
            };
            this.sociedadLista.push(sociedad);
        } 
      },
      error => {
        console.trace();
        if (error.status === 0) {
          this.showMessage('error', 'Error de conexión', 'No existe conexión para obtener las sociedades');
        } else if (error.status === 403) {
          this.showMessage('error', 'La sesión expiro', 'Tiempo de sesión expirado');
          this.goLogin();
        } else {
          this.showMessage('error', 'Error en el servidor', 'Error desconocido, contacte con TuVidaDigital');
          this.goLogin();
        }
      },
      () => {
        console.log('CUANTOS HAY EN LA LISTA ----> ' + this.sociedadLista.length);
        this.spinner.hide();
      }
    );
  }  

  goLogin() {
    localStorage.clear();
    this.router.navigate(['/']);
  }

  showMessage(tipo: string, titulo: string, descripcion: string) {
    switch (tipo) {
      case 'success':
        this.toastr.success(descripcion, titulo);
        break;
      case 'error':
        this.toastr.error(descripcion, titulo);
        break;
      case 'warning':
        this.toastr.warning(descripcion, titulo);
        break;
      case 'info':
        this.toastr.info(descripcion, titulo);
        break;
    }
  }

  generarVersiones (rfc: string) {
    let numero: number;
    // this.mostrarApertura = false;
    // this.mostrarAsamblea = false;
    // this.mostrarAumento = false;
    //let version = 1;
    this.selectedSociety = rfc;
    console.log('Generar Versiones: ->' + rfc);
    console.log('Generar Versiones 2: ->' + this.selectedSociety);
    
    this.listaVersion = [];
    for (let i = 0; i < this.sociedadLista.length; i++) {
      if (this.sociedadLista[i].rfc === rfc) {
        this.tipoSociedad = this.sociedadLista[i].tipo;
        numero = this.sociedadLista[i].concepto.length;
        for (let z = 0; z < numero; z++) {
          let lista: MostrarVersiones = {
            concepto: this.sociedadLista[i].concepto[z],
            fecha: this.sociedadLista[i].fecha[z]
          };
          this.listaVersion.push(lista);
        }
        this.listaVersionMostrar = true;
        // this.mostrarDash = false;
        i = this.sociedadLista.length;
      }
    }
  }

  // Method to emit the selected value
  onSocietyChange(selectedValue: string) {
    this.societySelected.emit(selectedValue); // Emit the selected value to the parent component
  }


}
